import script from "./messageBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./messageBoard.vue?vue&type=script&setup=true&lang=js"

import "./messageBoard.vue?vue&type=style&index=0&id=39010808&lang=scss"

const __exports__ = script;

export default __exports__